module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/5/4-d28178d5ad228beb28e717d0b6960c56.jpg";